import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";


import { Provider } from "react-redux";
import store from "./redux/index.js";
import App from "./App";
import theme from "./themeConfig";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { dsnSentry, envSentry } from "./config/config";
// import { BrowserClient } from "@sentry/browser";
Sentry.init({

  dsn: dsnSentry,
  environment: envSentry

});

// console.log("el sentry", dsnSentry, envSentry, Sentry);
// Sentry.captureMessage('Hello, world-30303022!');



// const client = new BrowserClient({
//   dsn: "https://28900ad3b70a43cdb020d94d069070a1@desa-sentry.superdesalud.gob.cl/4",
// });

// client.captureException(new Error("example-hhtps-domain"));

ReactDOM.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
  document.getElementById("root")
);
